export default __webpack_public_path__ + "static/media/avatar_alison9.9a754bcf.mp3";